import styled, { css } from 'styled-components';
import { animated } from 'react-spring';
import { device } from '../../styles/devices';
import { COLORS, SIZING } from '../../styles/variables';

export const NavWrapper = styled(animated.div)`
  position: fixed;
  bottom: 0;
  right: 0;
  background-color: ${COLORS.grey80};
  width: 100%;
  z-index: 100;
  padding: ${SIZING.unit(2.5)} ${SIZING.unit(2)};
  @media ${device.tablet} {
    padding: ${SIZING.unit(2.5)} ${SIZING.unit(5)};
    height: 127px;
  }
  @media ${device.laptopL} {
    padding: ${SIZING.unit(2.5)} ${SIZING.unit(7.5)};
  }
`;

export const Nav = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  color: ${COLORS.white};
  font-family: 'Audi Type';
  font-size: 12px;
  justify-content: space-between;
  @media ${device.tablet} {
    flex-direction: row;
    align-items: center;
  }
`;

export const A = styled.a`
  color: ${COLORS.white};
  cursor: pointer;
`;

export const ModelInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  @media ${device.tablet} {
    flex: 1;
  }
`;

export const ModelName = styled.div`
  font-size: 20px;
  font-weight: bold;
  line-height: 32px;
`;

export const TextContainer = styled.div`
  width: 98%;
  margin: 20px auto;
  font-family: 'Audi Type';
  font-size: 13px;
  line-height: 1.1;
  @media ${device.tablet} {
    line-height: 1.2;
    margin: 60px auto;
  }
`;

export const Legal = styled.div`
  margin: 15px 0 60px;
  @media ${device.tablet} {
    margin: 61px 0 60px;
  }
`;

export const LegalCTA = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
`;

export const InfoIconWrapper = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  margin-left: 0px;
  padding: 1px 6px;
`;

export const PriceBlockContainer = styled.div`
  font-family: 'Audi Type';
  color: ${COLORS.white};
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  @media ${device.tablet} {
    flex-direction: column;
  }
  @media ${device.laptop} {
    flex-direction: row;
  }
`;

export const ContactDealerText = styled.p`
  font-size: 16px;
  line-height: 24px;
  color: ${COLORS.white};
`;

export const PriceCopy = styled.p`
  font-size: 16px;
  line-height: 24px;
  text-align: flex-start;
  color: ${COLORS.grey5};
`;

export const VehiclePrice = styled.p`
  position: relative;
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
  white-space: nowrap;
  color: ${COLORS.grey5};
`;

export const PriceContainer = styled.div`
  display: flex;
  margin-left: ${SIZING.unit(1)};
  align-items: flex-start;
  @media ${device.tablet} {
    margin-left: 0;
  }
  @media ${device.laptop} {
    margin-left: ${SIZING.unit(1)};
  }
`;

export const StatusBlockContainer = styled.div`
  font-family: 'Audi Type';
  display: flex;
  align-items: center;
`;

export const StatusBlockContent = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  background: rgba(255, 255, 255, 0.15);
  padding: ${SIZING.unit(0.5)} ${SIZING.unit(1.5)};
`;

export const StatusDot = styled.div<{ statusForDot: string }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: ${SIZING.unit(1)};
  ${({ statusForDot }) => {
    if (statusForDot === 'REVERVED')
      return css`
        background: ${COLORS.redRibbon};
      `;
    if (statusForDot === 'AVAILABLE')
      return css`
        background: ${COLORS.spaceInvader};
      `;
    return css`
      background: ${COLORS.flashOfOrange};
    `;
  }}
`;

export const StatusTitle = styled.div`
  margin-left: ${SIZING.unit(1)};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: ${COLORS.grey10};
`;
